import PageBlacklist from './pageBlacklist';
export default PageBlacklist;
